
import { Options, Vue }     from 'vue-class-component';
import MultiLevelSelectCard from './multi-level-select-card.vue';
import { uniqBy }       from 'lodash';

@Options({
  props     : ['items','selected'],
  components: {
    MultiLevelSelectCard
  },
  watch     : {
    items(items) {
      this.lines = this.$store.state.linijaList;
    }
  },
  methods : {
    isDesktop() {
      return window.matchMedia('(min-width: 769px)').matches;
    },
    showLines() {
      this.visibleLines = true;
    },
    showShapes() {
      this.visibleShapes = true;
    },
    showColor() {
      this.visibleColors = true;
    },
    hideLines() {
      this.visibleLines = false;
    },
    hideShapes() {
      this.visibleShapes = false;
    },
    hideColor() {
      this.visibleColors = false;
    },
    closeAll() {
      this.visibleColors = false;
      this.visibleShapes = false;
      this.visibleLines  = false;
    },
    finishSelecting() {
      this.closeAll();
    },
    listen(n, o) {

      if (o == 'lines') {
        this.showShapes();
        this.hideColor();
        this.valueLines = n.value;

        //Set attributes as objects

        let shapes  = this.items.filter(x => x.attributes.linija === this.valueLines).map(y => y.attributes.oblika);
        this.shapes = this.oblikaList.filter(x => shapes.indexOf(x.value) !== -1)

      } else if (o === 'shapes') {
        this.showColor();
        this.valueShapes = n.value;

        //Set attributes as objects
        let colors = this.items.filter(x => x.attributes.linija === this.valueLines && x.attributes.oblika === this.valueShapes).map(x => ({
            value: x.attributes.Barva,
            title: x.attributes.Barva,
            tile: true,
            thumbnail: x.thumbnail,
            newitem: x.attributes.newitem,
            discount: x.discount
        }));

        this.colors = uniqBy(colors, 'value')
      } else if (o === 'colors') {
        this.finishSelecting();
        this.valueColor = n.value;
        let output = this.items.filter(x => x.attributes.linija === this.valueLines && x.attributes.oblika === this.valueShapes && x.attributes.Barva == this.valueColor)[0];
        output.active = true
        for(let x = 0; x < this.$props.selected.length; x++){
            this.$props.selected[x].active = false;
        }

        if(typeof this.index === 'number'){
          this.$props.selected[this.index] = output;
        }
        else{
          this.$props.selected.push(output);
        }
      }
    }
  }

})
export default class MultiLevelSelect extends Vue {
  items: any;
  lines: any[];

  data() {
    return {
      visibleLines : false,
      index        : null,
      visibleShapes: false,
      visibleColors: false,
      lines        : [],
      shapes       : [],
      colors       : [],
      list         : [],
      valueLines   : null,
      valueShapes  : null,
      valueColor   : null,
      oblikaList   : this.$store.state.oblikaList
    };
  }

}

